  import React, { useEffect, useState } from 'react';
  import { Plane, Hotel, Mountain, Compass } from 'lucide-react';
  import { useNavigate } from 'react-router-dom';

  const ICON_MAP = {
    plane: <Plane size={40} className="text-kenya-orange" />,
    hotel: <Hotel size={40} className="text-kenya-orange" />,
    mountain: <Mountain size={40} className="text-kenya-orange" />,
    compass: <Compass size={40} className="text-kenya-orange" />,
  };

  const ServicesPage = () => {
    const [services, setServices] = useState([]);
    const navigate = useNavigate();

      useEffect(() => {
        fetch('https://python.rock-safaris.com/services/')
          .then(res => res.json())
          .then(data => setServices(data));
      }, []);

    return (
      <div>
        {/* Hero Section */}
        <section className="bg-kenya-yellow py-5">
          <div className="container text-center py-4">
            <h1 className="display-5 fw-bold text-kenya-brown mb-3">Our Services</h1>
            <p className="lead text-kenya-brown mx-auto" style={{ maxWidth: 700 }}>
              Comprehensive travel solutions designed to make your Kenyan adventure unforgettable
            </p>
          </div>
        </section>

        {/* Services Grid */}
        <section className="py-5 bg-kenya-white">
          <div className="container">
            <div className="row g-4">
              {services.map((service, idx) => (
                <div className="col-md-6" key={service.id}>
                  <div className="card shadow border-0 h-100">
                    <div className="card-body">
                      <div className="d-flex align-items-center mb-3">
                        {ICON_MAP[service.icon]}
                        <h4 className="fw-bold ms-3 text-kenya-brown">{service.title}</h4>
                      </div>
                      <p>{service.description}</p>
                      <ul className="list-unstyled mb-0">
                        {service.features.map((feature, i) => (
                          <li key={i} className="d-flex align-items-center mb-1">
                            <span className="me-2" style={{ color: 'var(--kenya-orange)' }}>•</span>
                            {feature.text}
                          </li>
                        ))}
                      </ul>
                      <button
                        className="btn btn-outline-kenya-orange mt-3"
                        onClick={() => navigate('/contact')}
                      >
                        Learn More
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-5 bg-kenya-orange text-white text-center">
          <div className="container py-4">
            <h2 className="fw-bold mb-3">Ready to Start Your Adventure?</h2>
            <p className="lead mb-4" style={{ color: 'var(--kenya-yellow)' }}>
              Let us handle every detail of your tour and safari, finding you that dream experience that fulfills your needs and provides value for your money.
            </p>
            <button
              className="btn btn-light text-kenya-orange fw-semibold px-4 py-2 shadow"
              onClick={() => navigate('/contact')}
            >
              Contact Us Today
            </button>
          </div>
        </section>
      </div>
    );
  };

  export default ServicesPage;